import React from 'react';
import { Course } from '../../../types/grades';
import { validateAndParseCredit } from '../../../utils/creditHandling';

interface CourseCreditsInputProps {
  course: Course;
  onChange: (updatedCourse: Course) => void;
}

export function CourseCreditsInput({ course, onChange }: CourseCreditsInputProps) {
  const handleChange = (value: string) => {
    const parsedValue = validateAndParseCredit(value);
    onChange({ ...course, credits: parsedValue ?? 0 });
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">
        Credits
      </label>
      <input
        type="text"
        value={course.credits || ''}
        onChange={(e) => handleChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md 
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   transition-colors duration-200"
        placeholder="0"
      />
    </div>
  );
}